import { createFileRoute } from '@tanstack/react-router';
import * as React from 'react';

import { PageHeader } from '@/components/dashboard/page-header';
import { RequesterIdentityForm } from '@/components/settings/requester-identity-form';

export const Route = createFileRoute('/_app/settings/identity')({
  component: IdentitySettingsPage,
});

function IdentitySettingsPage(): React.ReactElement {
  return (
    <div className="flex flex-col gap-6">
      <PageHeader
        title="Identité du donneur d'ordre"
        subtitle="Raison sociale et identifiant légal repris sur les devis officiels."
      />
      <RequesterIdentityForm />
    </div>
  );
}
